import type { FsId } from '@fullstory/recording-api';
import { fsStylesCss } from '@fullstory/styles';
import type { FsDocument } from './fsdocument';
import { FsNode } from './fsnode';

/** The vDOM representation of an {@link HTMLHeadElement} node. */
export class FsHeadElement extends FsNode {
  constructor(ownerDoc: FsDocument, fsid?: FsId) {
    super(ownerDoc, 'head', undefined, fsid);
    this._injectPlaybackHelpers();
  }

  protected createNode(doc: Document): HTMLHeadElement {
    return doc.createElement('head');
  }

  private _injectPlaybackHelpers(): void {
    // Inject a <base> element so that relative URLs get fetched correctly.
    const baseElem = this.ownerDoc.createHelperNode('base');
    baseElem.setAttr('href', this.ownerDoc.baseUrl, /* skipRewrite = */ true);
    this.appendChild(baseElem);

    // Inject a stylesheet containing our custom FS styles. This will
    // make the <html> element visible after the DOM settles. Note that
    // we don't want to rewrite the content of this stylesheet; it's
    // part of the playback implementation, and it needs to run on the
    // "bare metal".
    const styleText = this.ownerDoc.createHelperNode('#text');
    styleText.setText(fsStylesCss.toString(), /* skipRewrite = */ true);
    const style = this.ownerDoc.createHelperNode('style');
    style.appendChild(styleText);
    this.appendChild(style);
  }
}
